"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorControlsCheckbox = exports.RadioButton = exports.RichTextViewer = exports.CommonControlsSectionHeader = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.ApplicationWorkflowDisclaimerAction = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var player_rich_text_viewer_1 = require("player-rich-text-viewer");
exports.RichTextViewer = player_rich_text_viewer_1.default;
var player_radio_button_1 = require("player-radio-button");
exports.RadioButton = player_radio_button_1.default;
var Checkbox_1 = require("player-editor-controls/controls/Checkbox");
Object.defineProperty(exports, "EditorControlsCheckbox", { enumerable: true, get: function () { return Checkbox_1.Checkbox; } });
var ApplicationWorkflowDisclaimerAction = (function (_super) {
    __extends(ApplicationWorkflowDisclaimerAction, _super);
    function ApplicationWorkflowDisclaimerAction(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowDisclaimerAction.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowDisclaimerAction.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowDisclaimerAction.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowDisclaimerAction.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowDisclaimerAction.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowDisclaimerAction.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowDisclaimerAction.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowDisclaimerAction.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowDisclaimerAction.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterVertical: "Xsmall", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", children: [React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: $this.state.viewModel.actionItem.title, tag: $this.state.viewModel.parentTag })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "12", children: [React.createElement(player_rich_text_viewer_1.default, { key: 0, html: $this.state.viewModel.actionItem.instructions, allowedTags: $this.state.viewModel.constants.PRTV_ALLOWED_TAGS, allowedAttributes: $this.state.viewModel.constants.PRTV_ALLOWED_ATTRIBUTES })] }), React.createElement(GridCol_1.GridCol, { key: 2, width: "12", children: [React.createElement(PlayerSwitch, { key: 0, value: $this.state.viewModel.actionItem.isYesOrNoResponse, true: [React.createElement(player_radio_button_1.default, { key: 0, tag: "DisclaimerRadioButtonList", id: $this.state.viewModel.userYesNoId, selectedValue: $this.state.viewModel.yesNoSelected, items: $this.state.viewModel.yesNoItems, errorMessage: $this.state.viewModel.actionItem.errorMessage, onChange: _this._proxyEvent("userYesNoChange") })], false: [React.createElement(Checkbox_1.Checkbox, { key: 0, tag: "DisclaimerCheckbox", isChecked: $this.state.viewModel.actionItem.isAgreed, isEnabled: true, id: $this.state.viewModel.userAgreementId, label: $this.state.viewModel.agreementText, showLabel: true, errorMessage: $this.state.viewModel.actionItem.errorMessage, isRequired: !$this.state.viewModel.actionItem.continueIfDisagree, onChange: _this._proxyEvent("userAnswerChanged") })] })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkflowdisclaimeraction" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowDisclaimerAction.defaultProps = {
        actionItem: "", DisclaimerIAgreeText: "", DisclaimerYesText: "", DisclaimerNoText: "",
        onDataChanged: function () { }
    };
    return ApplicationWorkflowDisclaimerAction;
}(React.Component));
exports.ApplicationWorkflowDisclaimerAction = ApplicationWorkflowDisclaimerAction;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowDisclaimerAction"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowDisclaimerAction/ApplicationWorkflowDisclaimerAction.js
// module id = 589
// module chunks = 0